"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filter = void 0;
/* Single unit match checks */

function matches(expression, unit) {
  if (expression.substr(0, 6) === "state:" && expression.length > 6 || expression.substr(0, 10) === "profileid:" && expression.length > 10 || expression.substr(0, 11) === "devicetype:" && expression.length > 11 || expression.substr(0, 7) === "]C18004" && expression.length == 23 || expression.substr(0, 4) === "8004" && expression.length == 20) {
    return fixedMatches(expression, unit);
  }

  return wildCardMatches(expression, unit);
}

function wildCardMatches(expression, unit) {
  var e_1, _a; // TODO: sort these expression by likelihood of usage


  if (unit.uuid.contains(expression)) {
    return true;
  } else if (unit.assetid && unit.assetid.toLowerCase().indexOf(expression.toLowerCase()) > -1) {
    return true;
  } else if (unit.giai && unit.giai.indexOf(expression) > -1) {
    return true;
  } else if (unit.version && unit.version.indexOf(expression) > -1) {
    return true;
  } else if (unit.status && unit.status.state && unit.status.state.toLowerCase().indexOf(expression.toLowerCase()) > -1) {
    return true;
  } else if (unit.meters && unit.meters[0].id && unit.meters[0].id.indexOf(expression) > -1) {
    return true;
  } else if (unit.meters && unit.meters[0].code && unit.meters[0].code.indexOf(expression) > -1) {
    return true;
  } else if (unit.meters && unit.meters[0].customerID && unit.meters[0].customerID.indexOf(expression) > -1) {
    return true;
  } else if (unit.location && unit.location.siteid && unit.location.siteid.toLowerCase().indexOf(expression.toLowerCase()) > -1) {
    return true;
  } else if (unit.location && unit.location.areaid && unit.location.areaid.toLowerCase().indexOf(expression.toLowerCase()) > -1) {
    return true;
  } else if (unit.location && unit.location.name && unit.location.name.toLowerCase().indexOf(expression.toLowerCase()) > -1) {
    return true;
  } else if (unit.location && unit.location.address && unit.location.address.toLowerCase().indexOf(expression.toLowerCase()) > -1) {
    return true;
  } else if (unit.modem && unit.modem.imei && unit.modem.imei.indexOf(expression) > -1) {
    return true;
  } else if (unit.modem && unit.modem.iccid && unit.modem.iccid.indexOf(expression) > -1) {
    return true;
  } else if (unit.modem && unit.modem.operator && unit.modem.operator.toLowerCase().indexOf(expression.toLowerCase()) > -1) {
    return true;
  } else if (unit.connections != null && unit.connections.length > 0) {
    try {
      for (var _b = __values(unit.connections), _c = _b.next(); !_c.done; _c = _b.next()) {
        var conn = _c.value;

        if (conn.hostname.indexOf(expression) > -1) {
          return true;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }

  return false;
}

var fixedMatches = function fixedMatches(expression, unit) {
  var e_2, _a;

  if (expression.substr(0, 6) === "state:" && expression.length > 6) {
    var s = expression.split(":")[1];

    if (s === "active") {
      if (unit.status.isActive()) {
        return true;
      }
    } else if (s === "passive") {
      if (unit.status.isPassive()) {
        return true;
      }
    } else if (s === "testing") {
      if (unit.status.isTesting()) {
        return true;
      }
    } else {
      if (unit['status'] && unit.status.state && unit.status.state === s) {
        return true;
      }
    }
  }

  if (expression.substr(0, 10) === "profileid:" && expression.length > 10) {
    if (unit.profile && unit.profile === parseInt(expression.split(":")[1])) {
      return true;
    }
  }

  if (expression.substr(0, 11) === "devicetype:" && expression.length > 11) {
    if (expression[11] === "!") {
      if (unit.deviceType == null || unit.deviceType !== parseInt(expression.split("!")[1])) {
        return true;
      }
    } else {
      if (unit.deviceType != null && unit.deviceType === parseInt(expression.split(":")[1])) {
        return true;
      }
    }
  }

  if (expression.substr(0, 7) === "]C18004" && expression.length == 23 || expression.substr(0, 4) === "8004" && expression.length == 20) {
    // GIAI
    var term = expression.substr(4);

    if (expression.length == 23) {
      term = expression.substr(7);
    }

    if (unit.giai != null && unit.giai.indexOf(term) > -1) {
      return true;
    }

    if (unit.meters != null && unit.meters.length > 0) {
      try {
        for (var _b = __values(unit.meters), _c = _b.next(); !_c.done; _c = _b.next()) {
          var meter = _c.value;

          if (meter.customerID != null && meter.customerID.indexOf(term) > -1) {
            return true;
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    }
  }

  return false;
};
/* Unit array operations */


function expressionFilter(expression, units) {
  var e_3, _a;

  var ret = [];

  try {
    for (var units_1 = __values(units), units_1_1 = units_1.next(); !units_1_1.done; units_1_1 = units_1.next()) {
      var unit = units_1_1.value;

      if (matches(expression, unit)) {
        ret.push(unit);
      }
    }
  } catch (e_3_1) {
    e_3 = {
      error: e_3_1
    };
  } finally {
    try {
      if (units_1_1 && !units_1_1.done && (_a = units_1.return)) _a.call(units_1);
    } finally {
      if (e_3) throw e_3.error;
    }
  }

  return ret;
}
/* Merges two arrays using OR (union) */


function orMerge(results1, results2) {
  var e_4, _a, e_5, _b;

  var ret = results2;

  try {
    for (var results1_1 = __values(results1), results1_1_1 = results1_1.next(); !results1_1_1.done; results1_1_1 = results1_1.next()) {
      var u1 = results1_1_1.value;
      var found = false;

      try {
        for (var results2_1 = (e_5 = void 0, __values(results2)), results2_1_1 = results2_1.next(); !results2_1_1.done; results2_1_1 = results2_1.next()) {
          var u2 = results2_1_1.value;

          if (u1.uuid.equals(u2.uuid)) {
            found = true;
            break;
          }
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (results2_1_1 && !results2_1_1.done && (_b = results2_1.return)) _b.call(results2_1);
        } finally {
          if (e_5) throw e_5.error;
        }
      }

      if (!found) {
        ret.push(u1);
      }
    }
  } catch (e_4_1) {
    e_4 = {
      error: e_4_1
    };
  } finally {
    try {
      if (results1_1_1 && !results1_1_1.done && (_a = results1_1.return)) _a.call(results1_1);
    } finally {
      if (e_4) throw e_4.error;
    }
  }

  return ret;
}
/* Merges two arrays using AND (intersection) */


function andMerge(results1, results2) {
  var e_6, _a, e_7, _b;

  var ret = [];

  try {
    for (var results1_2 = __values(results1), results1_2_1 = results1_2.next(); !results1_2_1.done; results1_2_1 = results1_2.next()) {
      var u1 = results1_2_1.value;
      var found = false;

      try {
        for (var results2_2 = (e_7 = void 0, __values(results2)), results2_2_1 = results2_2.next(); !results2_2_1.done; results2_2_1 = results2_2.next()) {
          var u2 = results2_2_1.value;

          if (u1.uuid.equals(u2.uuid)) {
            found = true;
            break;
          }
        }
      } catch (e_7_1) {
        e_7 = {
          error: e_7_1
        };
      } finally {
        try {
          if (results2_2_1 && !results2_2_1.done && (_b = results2_2.return)) _b.call(results2_2);
        } finally {
          if (e_7) throw e_7.error;
        }
      }

      if (found) {
        ret.push(u1);
      }
    }
  } catch (e_6_1) {
    e_6 = {
      error: e_6_1
    };
  } finally {
    try {
      if (results1_2_1 && !results1_2_1.done && (_a = results1_2.return)) _a.call(results1_2);
    } finally {
      if (e_6) throw e_6.error;
    }
  }

  return ret;
}
/* Filter logic helpers */


function orComponents(term) {
  return term.split(" OR");
}

function andComponents(term) {
  return term.split(" AND");
}
/* Performs the full and search of the terms (splitting by AND and searching each subcomponent) */


function andSearch(term, units) {
  var andTerms = andComponents(term);
  var results = expressionFilter(andTerms[0].trim(), units);

  for (var i = 1; i < andTerms.length; i++) {
    results = andMerge(results, expressionFilter(andTerms[i].trim(), units));
  }

  return results;
}

function filter(units, expression) {
  /* Actual work starts here */
  if (expression && expression.length > 1) {
    var results = [];
    var orConstructs = orComponents(expression);
    var results = andSearch(orConstructs[0], units);

    for (var i = 1; i < orConstructs.length; i++) {
      results = orMerge(results, andSearch(orConstructs[i], units));
    }

    return results;
  }

  return units;
}

exports.filter = filter;